import { useCampaignContext, useEditorContext } from 'modules/campaigns/editor/context';
import { canAddExperiment } from 'modules/campaigns/editor/utils';
import { getLatestExperiment } from 'modules/campaigns/lib/utils/experiment';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';
import { LightText, SectionHeader } from '../Sections.styled';
import { AddExperiment } from './AddExperiment';
import { ExperimentLink } from './ExperimentLink';
import { ExperimentContainer } from './Experiments.styled';

export const Experiments = () => {
  const { campaign } = useCampaignContext();
  const { campaignSteps } = useEditorContext();

  const isEditable = campaignSteps?.ConversionAndExperiment?.isEditable;

  const experiments = useWatch({ name: 'experiments' });

  const { experiments: campaignExperiments } = experiments;
  const experiment = useMemo(() => getLatestExperiment(campaignExperiments), [campaignExperiments]);

  return (
    <>
      <SectionHeader>Experiments</SectionHeader>

      <CampaignFormField labelText="A/B experiment" $removeMarginBottom={!experiment}>
        {!isEditable && (
          <ReadOnlyField name="experiments">
            {experiment ? (
              <ExperimentLink experiment={experiment} />
            ) : (
              <LightText>Not set</LightText>
            )}
          </ReadOnlyField>
        )}

        {isEditable && (
          <ExperimentContainer>
            {experiment && <ExperimentLink experiment={experiment} />}
            {canAddExperiment(campaign, experiment) && <AddExperiment />}
          </ExperimentContainer>
        )}
      </CampaignFormField>
      {experiment && (
        <CampaignFormField labelText="Status">
          <ReadOnlyField name="experimentStatus">{experiment.state}</ReadOnlyField>
        </CampaignFormField>
      )}
    </>
  );
};
